// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"135":"f143db6b","440":"01c8584e","670":"434ff33a","808":"2ac5f0f8"}[chunkId] + ".chunk.js";
};